module.exports = __webpack_public_path__ + "07c7b22affedb39f922fa38f9bce403c.MP3";